// extracted by mini-css-extract-plugin
export var aircallIframe = "_mz-3";
export var fabContainer = "_mz-5";
export var fabRinging = "_mz-6";
export var loadingOverlay = "_mz-4";
export var pulse = "_mz-7";
export var widgetContent = "_mz-2";
export var widgetPanel = "_mz-0";
export var widgetPanelExpanded = "_mz-1";